import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchWarehouse(serviceProviderId, warehouseId) {
    return RequesterV1.get(
      `service_provider/warehouse/movements/${serviceProviderId}/show_warehouse/${warehouseId}`
    );
  },

  fetchInventoryUnits(serviceProviderId, warehouseId) {
    return RequesterV1.get(
      `service_provider/warehouse/movements/${serviceProviderId}/manage_inventory_items/fetch_inventory_units/${warehouseId}`
    );
  },

  fetchInventoryItem(serviceProviderId, warehouseId, inventoryItemId) {
    return RequesterV1.get(
      `service_provider/warehouse/movements/${serviceProviderId}/manage_inventory_items/fetch_inventory_item/${warehouseId}/${inventoryItemId}`
    );
  },

  create(serviceProviderId, warehouseId, inventory_item) {
    return RequesterV1.post(
      `service_provider/warehouse/movements/${serviceProviderId}/manage_inventory_items/create/${warehouseId}`,
      { inventory_item }
    );
  },

  update(serviceProviderId, warehouseId, inventoryItemId, inventory_item) {
    return RequesterV1.post(
      `service_provider/warehouse/movements/${serviceProviderId}/manage_inventory_items/update/${warehouseId}/${inventoryItemId}`,
      { inventory_item }
    );
  },

  destroy(serviceProviderId, warehouseId, inventoryItemId) {
    return RequesterV1.delete(
      `service_provider/warehouse/movements/${serviceProviderId}/manage_inventory_items/destroy/${warehouseId}/${inventoryItemId}`,
    );
  }
};
